import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20style%20beautiful%20fantasy%20library%20with%20floating%20books%20and%20magical%20glowing%20orbs%2C%20cherry%20blossom%20petals%20drifting%20through%20sunlight%2C%20warm%20golden%20hour%20lighting%20streaming%20through%20tall%20windows%2C%20ethereal%20and%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%20with%20touches%20of%20amber%20and%20rose%2C%20Japanese%20anime%20art%20style%20background%20illustration&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
        alt="今日同人库 - 每日精选同人作品聚合平台"
        title="今日同人库 - 同人作品每日推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl">
          发现最精彩的<span className="text-accent-400">同人</span>世界
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/novel"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30 hover:shadow-xl hover:shadow-primary-500/40"
          >
            探索作品
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm font-medium rounded-full text-sm md:text-base transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 md:mt-14 flex items-center gap-6 md:gap-10">
          {[
            { value: '50万+', label: '月活跃用户' },
            { value: '10万+', label: '收录作品' },
            { value: '3000+', label: '合作创作者' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/65 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}